module.exports = __webpack_public_path__ + "img/rechargeStatus.4cdc8a94.png";